import { render, staticRenderFns } from "./leftTree.vue?vue&type=template&id=ef618f7c&scoped=true&"
import script from "./leftTree.vue?vue&type=script&lang=js&"
export * from "./leftTree.vue?vue&type=script&lang=js&"
import style0 from "./leftTree.vue?vue&type=style&index=0&id=ef618f7c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef618f7c",
  null
  
)

export default component.exports